import type {
  CompleteYardGatePortariaStep,
  YardJourneyCompleteStep,
  YardJourneyDto,
  YardJourneyEnvelopeDto,
} from 'contracts/YardJourneyExecution';
import { api } from 'services';

const apiRoot = (api.defaults.baseURL || '').replace(/\/dashboard\/?$/, '');
const journeysPath = (orderId: number) =>
  `${apiRoot}/api/v1/yms-portaria/orders/${orderId}/journey`;

export const getYardGateJourney = async (
  orderId: number
): Promise<YardJourneyEnvelopeDto> => {
  const { data } = await api.get<YardJourneyEnvelopeDto>(journeysPath(orderId));
  return data;
};

export const confirmYardGateJourney = async (
  orderId: number,
  yardFlowId: number
): Promise<YardJourneyDto> => {
  const { data } = await api.post<YardJourneyDto>(journeysPath(orderId), {
    yardFlowId,
  });
  return data;
};

export const completeYardGatePortariaStep = async (
  orderId: number,
  payload: CompleteYardGatePortariaStep
): Promise<YardJourneyDto> => {
  const { data } = await api.post<YardJourneyDto>(
    `${journeysPath(orderId)}/portaria/complete`,
    payload
  );
  return data;
};

export const startYardGateJourneyStep = async (
  orderId: number,
  stepId: number,
  expectedStepId: number
): Promise<YardJourneyDto> => {
  const { data } = await api.post<YardJourneyDto>(
    `${journeysPath(orderId)}/steps/${stepId}/start`,
    { expectedStepId }
  );
  return data;
};

export const finishYardGateJourneyStep = async (
  orderId: number,
  stepId: number,
  payload: YardJourneyCompleteStep
): Promise<YardJourneyDto> => {
  const { data } = await api.post<YardJourneyDto>(
    `${journeysPath(orderId)}/steps/${stepId}/finish`,
    payload
  );
  return data;
};

export function useYardGateJourney() {
  return {
    getYardGateJourney,
    confirmYardGateJourney,
    completeYardGatePortariaStep,
    startYardGateJourneyStep,
    finishYardGateJourneyStep,
  };
}
